import * as yup from 'yup';

export const schemaCertificateConformity = yup.object().shape({
  user: yup.string().nullable().required('Campo obbligatorio'),
  pin: yup.string().nullable().required('Campo obbligatorio'),
  // otp: yup.string().nullable().required('Campo obbligatorio'),
});
